<template>
    <div class="bg-white">
        <!-- <Mainlayout></Mainlayout> -->
        <div class="cashier-page" style="background-size: cover;">
            <!-- Header -->
            <div style="width:90%;margin:0 auto">
                <CRow class="align-items-center justify-content-between mt-4 p-0">
                    <CCol class="d-flex align-items-center mb-4">
                        <div class="profile-avatar bg-grey"></div>
                        <img :src="user.avatar" alt="" class="avatar" />
                        <div class="ml-2">
                            <h3 class="profile-name m-0 custom-12px-400">Welcome</h3>
                            <p class="profile-username m-0 custom-16px-600">{{ user.name }}</p>
                        </div>
                    </CCol>
                    <!-- Right: Search & Notification Icons -->
                    <CCol class="d-flex align-items-center justify-content-end mb-3">
                        <img :src="icons.search" width="20px" class="me-2" />
                        <img :src="icons.bell" width="16px" class="ml-2 ml-4" />
                    </CCol>
                </CRow>
            </div>
            <!-- Hero Card -->
            <div class="hero-card">
                <img :src="images.hero" class="hero-bg" alt="Hero Background" />
                <div class="hero-content">
                    <p class="hero-text"> Manage reward </br>redemptions and point </br>collections in real-time.</p>
                    <CButton class="custom-border-purple text-white">Get Started</CButton>
                </div>
            </div>
            <!-- QR Card -->
            <div class="qr-card d-flex align-items-center justify-content-between">
                <p class="m-0">QR Code to Collect Points<br /><small>Show this QR Code to customer</small></p>
                <img :src="images.qrMini" width="40" />
            </div>
          
            <div class="section">
                <!-- ✅ Tabs (Full Width) -->
                <div class="tabs d-flex mb-3 w-100">
                    <div :class="['tab', activeTab === 'points' ? 'active' : '']" @click="activeTab = 'points'">
                        Collect Points
                    </div>
                    <div :class="['tab', activeTab === 'rewards' ? 'active' : '']" @click="activeTab = 'rewards'">
                        Reward Claims
                    </div>
                </div>
                <!-- ✅ Header -->
                <div class="section-head d-flex justify-content-between align-items-center mb-2">
                    <h4 class="section-title">Request</h4>
                    <span class="link">See All</span>
                </div>
                <!-- ✅ Requests count -->
                <p>
                    <span class="text-danger">
                                                    {{ activeTab === 'points' ? pendingRequests.length : pendingRewardRequests.length }}
                                                    Requests
                                                    </span>
                    <span class="text-black"> for Approval</span>
                </p>
                <!-- ✅ List -->
                <div v-for="(req, index) in activeTab === 'points' ? pendingRequests : pendingRewardRequests" :key="index" class="pending-item d-flex align-items-center justify-content-between" @click="openRequest(req)">
                    <div class="d-flex align-items-center">
                        <div class="profile-avatar bg-grey"></div>
                        <div class="ml-2">
                            <h4 class="text-black">{{ req.Name }}</h4>
                            <!-- <p class="m-0">{{ req.SessionId }}</p> -->
                            <CButton class="purple-bg text-white btn-sm">
                                {{ activeTab === 'points' ? 'Collect Point Request' : 'Reward Request' }}
                            </CButton>
                        </div>
                    </div>
                    <small class="text-muted">
                                                    {{ req.CreatedDate | moment("DD/MM/YYYY, HH:mm:ss") }}
                                                    </small>
                </div>
            </div>
            <!-- Recent Approvals -->
            <div class="section">
                <h4 class="section-title">Recent Approvals</h4>
                <div v-for="(app, i) in recentApprovals" :key="i" class="approval-item d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-start">
                        <!-- grey circle with check -->
                        <div class="check-dot">
                            <span>✔</span>
                        </div>
                        <p class="m-0">
                            <strong>{{ app.user }}</strong> claimed
                            <template v-if="app.type === 'reward'">
                                                                {{ app.detail }}
</template>

<template v-else>
     {{ app.points }} Points
</template>
                                                <br />
                                                <small class="time">{{ app.when }}</small>
                                            </p>
                                        </div>

                                        <span class="status" :class="app.status === 'Rejected' ? 'text-danger' : 'text-success'">
                            {{ app.status || 'Approved' }}
                            </span>
                                        </div>
                                    </div>
                                    </div>


        <!-- Backdrop -->
        <div v-if="showRequestModal || showRequestRewardModal" class="backdrop" @click="closeAllSheets"></div>

            <!-- Request Popup -->
            <div v-if="showRequestModal" class="sheet">
            <div class="sheet-handle"></div>
            <div class="text-center">
                <div class="avatar-lg bg-grey"></div>
                <h3 class="sheet-title">
                {{ selectedRequest.Name }} is requesting to collect points.
                </h3>
                <p class="sheet-sub">
                Please review the request details and approve if valid.
                </p>
            </div>

            <div class="details-card">
                <h5 class="details-title">Request Details:</h5>
                <div class="row-line">
                <span>Customer Name</span>
                <strong>{{ selectedRequest.Name }}</strong>
                </div>
                <div class="row-line">
                <span>Phone/Email</span>
                <strong>{{ selectedRequest.Email || selectedRequest.PhoneNumber }}</strong>
                </div>
            </div>

            <div class="details-card mt-3">
                <h5 class="details-title font-color-171717">Total Price From Receipt</h5>
                <label class="font-color-171717">Enter Total Price</label>
                <input
                type="number"
                class="price-input"
                placeholder="MYR 0.00"
                v-model="selectedRequest.totalPrice"
                />
            </div>

            <div class="text-center mt-3 mb-3">
                <a href="#" class="view-receipt" @click.prevent="OpenReceipt(selectedRequest.SessionId)">
                View Receipt
                </a>
            </div>
            <CAlert v-if="InfoMessage" show color="danger">
                            <strong>Error!</strong> {{ Message }}
                        </CAlert>

            <div class="actions">
                <button class="btn-reject" @click="rejectRequest(selectedRequest)">Reject</button>
                <button class="btn-approve" @click="approveRequest(selectedRequest)">Approve</button>
                <button class="btn-cancel" @click="closeRequest">Close</button>
            </div>
            </div>




            <div v-if="showRequestRewardModal" class="sheet">
            <div class="sheet-handle"></div>
            <div class="text-center">
                <div class="avatar-lg bg-grey"></div>
                <h3 class="sheet-title">
                {{ selectedRequest.Name }} is requesting to claim rewards.
                </h3>
                <p class="sheet-sub">
                Please review the request details and approve if valid.
                </p>
            </div>

            <div class="details-card">
                <h5 class="details-title">Request Details:</h5>
                <div class="row-line">
                <span>Customer Name</span>
                <strong>{{ selectedRequest.Name }}</strong>
                </div>
                <div class="row-line">
                <span>Phone/Email</span>
                <strong>{{ selectedRequest.Email || selectedRequest.PhoneNumber }}</strong>
                </div>

                <div class="row-line">
                <span>Name Of Reward</span>
                <strong>{{ selectedRequest.CampaignTitle }}</strong>
                </div>
            </div>

         

            <CAlert v-if="InfoMessageReward" show color="danger">
                            <strong>Error!</strong> {{ Message }}
                        </CAlert>

            <div class="actions">
                <button class="btn-reject" @click="rejectRewardRequest(selectedRequest)">Reject</button>
                <button class="btn-approve" @click="approveRewardRequest(selectedRequest)">Approve</button>
                <button class="btn-cancel" @click="closeRequestReward">Close</button>
            </div>
            </div>


         <!-- Receipt Modal -->
            <div v-if="showReceiptModal" class="sheet">
            <div class="sheet-handle"></div>

            <div class="text-center">
                <h3 class="sheet-title">Collection Point Receipt</h3>
                <p class="sheet-sub">Below is the valid receipt for this collection point</p>

                <CCard class="bg-f5f5f5">
                <div class="text-center" v-for="item in receipt" :key="item.Id">
                    <div class="receipt-image-wrapper">
                    <img :src="item.Url" width="200px" @click="enlargeImage(item.Url)"  v-c-tooltip="'Click image to view fullscreen'"/>
                   

<CIcon name="cil-justify-center"/>
                    </div>
                </div>
                </CCard>
            </div>

            <div class="actions">
                <CButton class="badge-purple bg-white" @click="closeReceipt" block>Close</CButton>
            </div>
            </div>

            <!-- Enlarge Modal -->
            <EnlargeImageModal
  :visible="showEnlargeModal"
  :image="selectedImage"
  @close="showEnlargeModal = false"
/>
            <br /><br /><br /><br />
            <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Footerlayout from "../containers/TheBottomCustom.vue";
import Mainlayout from "../containers/HeaderQR.vue";
import EnlargeImageModal from "../views/EnlargeModal.vue";
import { cilMagnifyingGlass } from '@coreui/icons';
import { CIcon } from '@coreui/icons-vue'
export default {
    name: 'CashierPage',
    components: {
        Footerlayout,
        Mainlayout,
        EnlargeImageModal,
        CIcon
    },
    data() {
        return {
            cilMagnifyingGlass,
            user: {
                name: 'John Nocloaos',
                avatar: require('@/assets/img/new/user-profile.png'),
            },
            images: {
                hero: require('@/assets/img/new/purple-bannerbg.png'),
                qrMini: require('@/assets/img/new/tinyQR.png'),
            },
            icons: {
                search: require('@/assets/img/new/smallicon/Search-black.png'),
                bell: require('@/assets/img/new/smallicon/noti-black.png'),
            },
            showRequestModal: false,
            selectedRequest: {},
            recentApprovals: [],
            showRequest: false,
            activeTab: "points", // default tab
            pendingRequests: [], // your data from API
            pendingRewardRequests: [], // your reward data from API
            showRequestRewardModal: false,
            selectedRewardRequest: {},
            showReceiptModal: false,
            receipt: [],
            showEnlargeModal: false,
            selectedImage: "",
            InfoMessage:false,
            InfoMessageReward: false
        };
    },
    async mounted() {
        try {
            // Check if the user is authorized
            const isAuth = await this.UserAuth();
            if (isAuth) {
                // If authenticated, get the user details
                this.GetInfoUser();
            } else {}
        } catch (error) {
            // Handle error, and ensure to redirect if there's an issue
            console.error("Error during authentication:", error);
        }
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true
                });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.GetListPending(this.user.companyId);
                    this.GetListPendingReward(this.user.companyId);
                } else {
                    // Handle failure to get user info if needed
                    console.error("Failed to fetch user info");
                    this.user = {
                        name: "Guest",
                        avatar: "/path/to/default/avatar.jpg",
                        username: "guest",
                        bio: "Welcome to our platform!",
                    };
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                this.user = {
                    name: "Guest",
                    avatar: "/path/to/default/avatar.jpg",
                    username: "guest",
                    bio: "Welcome to our platform!",
                };
            }
        },
        openRequest(req) {
            this.selectedRequest = req;
            if (this.activeTab === 'rewards' ||
                (req.action && req.action.toLowerCase().includes('reward'))) {
                // Reward flow
                this.showRequestRewardModal = true;
            } else {
                // Point flow
                this.showRequestModal = true;
            }
            document.body.style.overflow = 'hidden';
        },
        closeRequest() {
            this.showRequestModal = false;
            document.body.style.overflow = '';
        },
        closeRequestReward() {
            this.showRequestRewardModal = false;
            document.body.style.overflow = '';
        },
        approveRequest(req) {
            console.log('Approved:', req);
            this.SubmitClaim(req);
           
        },
        rejectRequest(req) {
            console.log('Rejected:', req);
            this.SubmitPointReject(req);
            this.closeRequest();
        },
        approveRewardRequest(req) {
            console.log('Approved:', req);
            this.SubmitRewardClaim(req);
        },
        rejectRewardRequest(req) {
            console.log('Rejected:', req);
            this.SubmitRewardRejectClaim(req);
            this.closeRequestReward();
        },
        async GetListPending(companyId) {
            try {
                const response = await this.$API.get(this.$GetListCompanyCodePointAsyncNotApproved + "?companyId=" + companyId, {
                    withCredentials: true
                });
                if (response.status === 200 && response.data) {
                    this.pendingRequests = response.data;
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        async GetListPendingReward(companyId) {
            try {
                const response = await this.$API.get(this.$GetListRedeemCampaignNotApproved + "?companyId=" + companyId, {
                    withCredentials: true
                });
                if (response.status === 200 && response.data) {
                    this.pendingRewardRequests = response.data;
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        SubmitClaim(req) {
  const formData = new FormData();
  formData.append("sessionId", req.SessionId);
  formData.append("status", "approved");
  formData.append("amount", req.totalPrice);

  return this.$API
    .post(this.$UpdateUserPoint, formData)
    .then((response) => {
      if (response.status === 200) {
        // ✅ success flow
        this.recentApprovals.unshift({
          user: req.Name,
          type: req.action && req.action.toLowerCase().includes("reward") ? "reward" : "points",
          detail: req.action && req.action.toLowerCase().includes("reward") ? (req.rewardName || "Reward") : null,
          points: req.points || null,
          when: "Just now",
        });
        this.GetListPending(this.user.companyId);
        this.closeRequest();
      }
    })
    .catch((error) => {
      // ✅ Handle all non-200 responses (400, 404, 500, etc.)
      this.InfoMessage = true;
      this.Message =
        (error.response && error.response.data && (error.response.data.message || error.response.data)) ||
        "Something went wrong. Please try again.";

      console.error("Error approving claim:", error.response || error);
    })
    .finally(() => {
      this.lblProcess = false;
    });
},
        SubmitRewardClaim(req) {
            const formData = new FormData();
            formData.append("redeemId", req.RedeemId);
            formData.append("status", "approved");
            return this.$API
                .post(this.$ApproveRedeemCampaigns, formData)
                .then((response) => {
                    if (response.status === 200) {
                        // ✅ Add to recent approvals
                        this.recentApprovals.unshift({
                            user: req.Name,
                            type: req.action && req.action.toLowerCase().includes("reward") ? "reward" : "points",
                            detail: req.action && req.action.toLowerCase().includes("reward") ? (req.rewardName || "Reward") : null,
                            points: req.points || null,
                            when: "Just now",
                        });
                        this.GetListPendingReward(this.user.companyId);
                    } 
                })
                .catch((error) => {
                    this.InfoMessageReward = true;
      this.Message =
        (error.response && error.response.data && (error.response.data.message || error.response.data)) ||
        "Something went wrong. Please try again.";

      console.error("Error approving claim:", error.response || error);
                })
                .finally(() => {
                    this.lblProcess = false;
                });
        },
        SubmitRewardRejectClaim(req) {
            const formData = new FormData();
            formData.append("redeemId", req.RedeemId);
            formData.append("status", "rejected");
            return this.$API
                .post(this.$ApproveRedeemCampaigns, formData)
                .then((response) => {
                    if (response.status === 200) {
                        // ✅ Add to recent approvals
                        this.recentApprovals.unshift({
                            user: req.Name,
                            type: req.action && req.action.toLowerCase().includes("reward") ? "reward" : "points",
                            detail: req.action && req.action.toLowerCase().includes("reward") ? (req.rewardName || "Reward") : null,
                            points: req.points || null,
                            when: "Just now",
                        });
                    } else {
                        this.ErrorMessage = true;
                        this.Message = "Invalid code. Please try again.";
                    }
                })
                .catch((error) => {
                    this.Error = true;
                    this.Message =
                        (error && error.response && error.response.data && error.response.data.message) ||
                        "Network error.";
                    this.ErrorMessage = true;
                })
                .finally(() => {
                    this.lblProcess = false;
                });
        },
        SubmitPointReject(req) {
            const formData = new FormData();
            formData.append("sessionId", req.SessionId);
            formData.append("status", "rejected");

            return this.$API
                .post(this.$UpdateUserPoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        // ✅ Add to recent activity (mark as rejected)
                        this.recentApprovals.unshift({
                            user: req.Name,
                            type: req.action && req.action.toLowerCase().includes("reward") ? "reward" : "points",
                            detail: req.action && req.action.toLowerCase().includes("reward") ? (req.rewardName || "Reward") : null,
                            points: req.points || null,
                            when: "Just now",
                            status: "Rejected", // 👈 add this flag
                        });
                    } else {
                        this.ErrorMessage = true;
                        this.Message = "Invalid code. Please try again.";
                    }
                })
                .catch((error) => {
                    this.Error = true;
                    this.Message =
                        (error && error.response && error.response.data && error.response.data.message) ||
                        "Network error.";
                    this.ErrorMessage = true;
                })
                .finally(() => {
                    this.lblProcess = false;
                });
        },
        OpenReceipt(sessionId) {
            this.GetViewReceipt(sessionId);
            this.showReceiptModal = true;
        },
        async GetViewReceipt(sessionId) {
            try {
                const response = await this.$API.get(this.$GetReceiptVoucherDetails + "?sessionId=" + sessionId, {
                    withCredentials: true
                });
                if (response.status === 200 && response.data) {
                    this.receipt = response.data;
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        closeReceipt() {
            this.showReceiptModal = false;
        },
        closeAllSheets() {
            this.showRequestModal = false;
            this.showRequestRewardModal = false;
            this.showReceiptModal = false;
            document.body.style.overflow = '';
        },
        enlargeImage(url) {
            this.selectedImage = url;
            this.showEnlargeModal = true;
        },
        closeEnlargeModal()
        {
            this.showEnlargeModal = false;
        }
    },
    
};
</script>

<style scoped>
.cashier-page {
    min-height: 100vh;
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
    color: #101010;
    margin: auto;
    padding: 10px;
}

.purple-bg {
    background: #928AFD1A;
    border-radius: 8px;
}

/* Header */

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px 6px;
}

.header .left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
}

.welcome-label {
    font-size: 12px;
    color: #667085;
    display: block;
    line-height: 1;
}

.profile-username {
    white-space: nowrap;
    /* force text to stay in one line */
    overflow: hidden;
    /* prevent overflow */
}

.name {
    font-size: 16px;
    font-weight: 700;
    margin: 2px 0 0;
}

.icon-btn {
    background: transparent;
    border: 0;
    padding: 6px;
    margin-left: 6px;
}

.icon-btn img {
    width: 22px;
    height: 22px;
}

/* Cards / layout */

.card {
    background: #fff;
    border: 1px solid #EEF0F3;
    border-radius: 16px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.03);
}

.section {
    padding: 0 18px;
    margin-top: 16px;
}

.section-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.section-title {
    margin: 0 0 2px;
    font-size: 14px;
    font-weight: 700;
}

.text-danger {
    font-size: 12px;
    color: #EF4444;
    font-weight: 400;
}

.text-black {
    font-size: 12px;
    color: #9B9B9B;
    font-weight: 400;
}

.pending-item {
    background: #fff;
    border: 1px solid #EEF0F3;
    border-radius: 16px;
    padding: 12px;
    margin-top: 12px;
}

.profile-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #E5E7EB;
    /* grey circle */
}

.approval-item {
    padding: 12px 0;
    border-bottom: 1px solid #EEF0F3;
}

.check-dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #E6F9EE;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
}

.check-dot span {
    color: #22C55E;
    font-size: 16px;
    line-height: 1;
}

.status-approved {
    color: #22C55E;
    font-weight: 600;
}

.time {
    color: #7E73FD;
}

.link {
    color: #7E73FD;
}

.link-btn {
    background: none;
    border: 0;
    color: #7E73FD;
    font-weight: 600;
}

/* Hero */

.hero-card {
    position: relative;
    overflow: hidden;
    margin: 8px 18px 14px;
    border-radius: 9px;
    width: 100%;
    /* keep full width */
    height: 200px;
    /* fixed height */
}

.hero-bg {
    width: 98%;
    height: 100%;
    /* fill fixed height */
    object-fit: cover;
    /* crop instead of squishing */
    border-radius: 9px;
}

.hero-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 18px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
}

/* text styling */

.hero-text {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 12px;
    overflow: hidden;
}

/* button */

.hero-content .custom-border-purple {
    align-self: flex-start;
    /* keep it left */
    background: #FFFFFF;
    border-radius: 12px;
    font-weight: 600;
}

.text-white {
    color: #7E73FD !important;
}

/* QR card */

.qr-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    margin: 0 18px;
    border: 1px solid #EDEDEE;
    border-radius: 16px;
}

.qr-title {
    margin: 0 0 4px;
    font-size: 14px;
    font-weight: 700;
}

.muted {
    color: #98A2B3;
    font-size: 12px;
    margin: 0;
}

.qr-mini {
    width: 28px;
    height: 28px;
}

/* Lists */

.list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.list-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
}

.list-item.compact {
    padding: 12px;
}

.chip {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    background: #EEF0F3;
}

.item-main {
    flex: 1;
    min-width: 0;
}

.item-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.item-title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
}

.time {
    font-size: 12px;
}

.pill {
    border: 0;
    background: #F1EDFF;
    color: #7E73FD;
    font-weight: 600;
    border-radius: 999px;
    padding: 6px 10px;
    margin-top: 8px;
    font-size: 12px;
}

.body {
    margin: 0 0 6px;
    color: #101010;
}

.status.ok {
    color: #21A67A;
    font-weight: 700;
}

.status-dot.ok {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: radial-gradient(#21A67A 52%, #E7F6F0 52%);
}

/* Tabbar */

.tabbar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #EEF0F3;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 10px 8px 14px;
    z-index: 5;
}

.tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background: none;
    border: 0;
}

.tab img {
    width: 24px;
    height: 24px;
}

.tab span {
    font-size: 12px;
    color: #98A2B3;
}

.tab.active span {
    color: #7E73FD;
}

.fab {
    width: 64px;
    height: 64px;
    background: #7E73FD;
    border-radius: 999px;
    border: 5px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -28px;
}

.fab img {
    width: 28px;
    height: 28px;
    filter: brightness(100);
}

/* Backdrop */

.backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .45);
    z-index: 1000;
}

/* Bottom sheet */

.sheet {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border-radius: 24px;
    padding: 10px 18px 24px;
    z-index: 1001;
    box-shadow: 0 -10px 30px rgba(16, 24, 40, .18);
    max-height: 85vh;
    overflow-y: auto;
    margin: 20px;
}

.sheet-handle {
    width: 40px;
    height: 4px;
    border-radius: 999px;
    background: #101828;
    margin: 0 auto 25px;
}

.avatar-lg {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    margin: 25px auto 15px;
}

.bg-grey {
    background: #E5E7EB;
}

.sheet-title {
    font-size: 22px;
    font-weight: 700;
    color: #101010;
    margin: 8px 0 8px;
}

.sheet-sub {
    color: #6B7280;
    margin: 0 0 16px;
    line-height: 1.4;
}

/* sheet B receipt */

.receipt-frame {
    display: flex;
    justify-content: center;
    margin: 16px 0;
}

.receipt-img {
    max-width: 80%;
    border: 1px solid #ddd;
    border-radius: 8px;
}

.details-card {
    border: 1px solid #EEF0F3;
    border-radius: 16px;
    padding: 16px;
    margin: 8px 0 14px;
    background-color: #F8F8F8;
}

.details-title {
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 10px;
}

.row-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #F2F4F7;
}

.row-line:last-child {
    border-bottom: 0;
}

.row-line span {
    color: #6B7280;
}

.row-line strong {
    color: #101010;
}

/* Layout for the link + two buttons */

.actions {
    display: flex;
    gap: 12px;
    margin-top: 8px;
}

.btn-reject {
    background: #EF4444;
    color: #fff;
    border: 0;
    flex: 1;
    padding: 14px 0;
    border-radius: 16px;
}

.btn-approve {
    background: #7E73FD;
    color: #fff;
    border: 0;
    flex: 1;
    padding: 14px 0;
    border-radius: 16px;
}

.tabs {
    background: #f4f4f4;
    border-radius: 30px;
    padding: 5px;
    width: fit-content;
    margin: 0 auto;
}

.tab {
    flex: 1;
    padding: 8px 20px;
    border-radius: 25px;
    text-align: center;
    font-weight: 600;
    color: #888;
    cursor: pointer;
    transition: all 0.3s;
}

.tab.active {
    background: white;
    color: black;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
}

.section-head .link {
    color: #7a73ff;
    cursor: pointer;
}

.profile-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ddd;
}

.purple-bg {
    background: #e5e2ff;
    color: #7a73ff !important;
    border: none;
}
</style>
